import React from 'react';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';

type Props = {
	show: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title?: string;
	message?: string;
	confirmText?: string;
	cancelText?: string;
	itemName?: string;
};

function ConfirmModal({ 
	show, 
	onClose, 
	onConfirm, 
	title = "정말 삭제하시겠습니까?",
	message = "삭제한 상자는 복구할 수 없습니다.",
	confirmText = "예",
	cancelText = "아니요",
	itemName = ""
}: Props) {
	const handleConfirm = () => {
		onConfirm();
		onClose();
	};

	return (
		<Modal
			show={show}
			close={onClose}
		>
			<div className="confirm-modal">
				<div className="confirm-modal-header">
					<h1>{title}</h1>
				</div>
				<div className="confirm-modal-body">
					<div className="confirm-modal-warning">
						{message}
					</div>
					{itemName && (
						<div className="confirm-modal-item-name">
							{itemName}
						</div>
					)}
				</div>
				<div className="btns">
					<Button 
						size="large"
						color="tertiary"
						onClick={onClose}
					>
						{cancelText}
					</Button>
					<Button 
						size="large"
						color="secondary"
						onClick={handleConfirm}
					>
						{confirmText}
					</Button>
				</div>
			</div>
		</Modal>
	);
}

export default ConfirmModal;
